module.exports = __webpack_public_path__ + "img/spade.bc074e9d.png";